
import PAAttendee from "./Attendee";


class IdeaComment {
    constructor(){

        const _temp = PAAttendee.generateRandomString(24);
        this.temp_id = _temp;
        this.id = _temp;

        this.attendee_id = "";
        this.comment = "";

    }
}

export default IdeaComment;
